import { CloudUpload, FilePresent } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function CustomFileUpload(props) {
  const {
    title,
    variant = "outlined",
    accept = ".tfstate",
    value,
    onChange,
  } = props;

  const [file, setFile] = useState(value);

  const handleFileChange = (event) => {
    const files = Object.values(event.target.files);
    setFile(files);
    onChange(files);
  };

  return (
    <>
      <Button
        component="label"
        role={undefined}
        variant={variant}
        tabIndex={-1}
        startIcon={<CloudUpload />}
      >
        {title}
        <VisuallyHiddenInput
          type="file"
          multiple
          accept={accept}
          onChange={handleFileChange}
        />
      </Button>
      {file && (
        <Box display="flex" alignItems="center" mt={2}>
          <FilePresent />
          <Typography variant="body1" ml={1}>
            {Object.values(file)
              .map((obj) => obj.name)
              .join(",")}
          </Typography>
        </Box>
      )}
    </>
  );
}
